const STORAGE_KEY = 'channel-h5-context'
let redirecting = false

/**
 * 保存服务端签发的渠道 H5 回跳上下文。
 * 这里只保存不可读 token 和有效期，禁止保存合作方明文地址。
 *
 * @param {Object} extendParams H5 登录扩展参数
 */
export function saveChannelH5Context (extendParams = {}) {
  const channelH5 = extendParams.channelH5
  if (!channelH5 || channelH5.enabled !== true || !channelH5.returnToken) {
    return
  }
  const context = {
    enabled: true,
    returnToken: channelH5.returnToken,
    source: channelH5.source,
    expireTime: channelH5.expireTime,
    borrowNo: channelH5.borrowNo,
    repayScope: channelH5.repayScope
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context))
}

/**
 * 获取当前标签页的渠道 H5 回跳上下文。
 *
 * @returns {Object|null} 未启用或已过期时返回 null
 */
export function getChannelH5Context () {
  try {
    const context = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null')
    if (!context || !context.enabled || !context.returnToken) return null
    if (context.expireTime && new Date(context.expireTime.replace(/-/g, '/')).getTime() <= Date.now()) {
      clearChannelH5Context()
      return null
    }
    return context
  } catch (error) {
    clearChannelH5Context()
    return null
  }
}

/**
 * 清除当前标签页的渠道 H5 回跳上下文。
 */
export function clearChannelH5Context () {
  sessionStorage.removeItem(STORAGE_KEY)
}

/**
 * 判断当前页面是否由渠道 H5 会话进入。
 *
 * @returns {boolean} true 表示可展示返回合作方入口
 */
export function hasChannelH5Return () {
  return Boolean(getChannelH5Context())
}

/**
 * 当前标签属于渠道 H5 会话时，直接解析并跳回合作方。
 *
 * @param {Object} router Vue Router 实例，仅用于在解析失败时展示当前页面提示
 * @returns {boolean} true 表示已接管本次返回动作
 */
export function redirectToChannelH5Return (router) {
  const context = getChannelH5Context()
  if (!router || !context) return false
  if (redirecting) return true
  redirecting = true
  let redirectSuccess = false
  // 动态加载接口模块，避免 network -> utils -> channel-h5-return 的静态循环依赖。
  import('@/api/system/channel-h5').then(({ apiResolveChannelH5Return }) => {
    return apiResolveChannelH5Return({ returnToken: context.returnToken })
  }).then(res => {
    if (res.code === 1000 && res.data && res.data.returnUrl) {
      redirectSuccess = true
      window.location.replace(res.data.returnUrl)
      return
    }
    handleReturnError(router, res.msg || '暂时无法返回，请稍后重试')
  }).catch(() => {
    handleReturnError(router, '网络异常，请稍后重试')
  }).finally(() => {
    if (!redirectSuccess) redirecting = false
  })
  return true
}

// 直接返回失败时留在原业务页面，避免再展示单独的失败中间页。
function handleReturnError (router, message) {
  const app = router && router.app
  if (app && typeof app.$toast === 'function') {
    app.$toast(message)
  }
}
